module.exports = __webpack_public_path__ + "img/grid-white-x2.8aabd1ca.png";